/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

const DigitalOrderNumber = ({
  digitalOrderNumber,
}) => {
  const {
    OrderId,
  } = useSelector((state) => state);

  return (
    <>
      <p>{OrderId}:</p>
      <p>{digitalOrderNumber.match(/(.{1,5})/g).join(' ')}</p>
      <br />
    </>
  );
};

DigitalOrderNumber.defaultProps = {
  digitalOrderNumber: '',
};

DigitalOrderNumber.propTypes = {
  digitalOrderNumber: PropTypes.string,
};

export default DigitalOrderNumber;
